import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sc-st-committee',
  templateUrl: './sc-st-committee.component.html',
  styleUrls: ['./sc-st-committee.component.scss']
})
export class ScStCommitteeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
